import { UserGender } from 'graphql-ts-types';

import { FROM_TITLE_PREFIX_TO_USER_GENDER } from '../constants/form';
import type { TitlePrefix } from '../enums/form';

export const getUserGender = (titlePrefix: TitlePrefix) =>
  FROM_TITLE_PREFIX_TO_USER_GENDER.get(titlePrefix) ?? UserGender.Undefined;
